"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const Sentry = __importStar(require("@sentry/browser"));
/**
 * Config for the router
 */
angular.module('callX')
    .config(['$stateProvider', '$locationProvider', '$urlRouterProvider', 'JQ_CONFIG', 'MODULE_CONFIG',
    function ($stateProvider, $locationProvider, $urlRouterProvider, JQ_CONFIG, MODULE_CONFIG) {
        $urlRouterProvider
            .otherwise('/access/login');
        $stateProvider
            .state('index', {
            url: '',
            redirectTo: { state: 'access.login' },
        })
            .state('access', {
            url: '/access',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
        })
            .state('access.login', {
            url: '/login',
            templateUrl: function () {
                return window.location.origin.includes('localhost') ? 'tpl/login.html' : 'tpl/loader.html';
            },
            controller: 'LoginCtrl'
        })
            .state('access.forgot-password', {
            url: '/forgot-password',
            templateUrl: 'tpl/forgot-password.html',
            controller: 'ForgotPasswordCtrl'
        })
            .state('access.sign-up', {
            url: '/sign-up',
            templateUrl: 'tpl/sign-up-new.html',
            controller: 'SignUpCtrl'
        })
            .state('access.confirmation', {
            url: '/confirmation',
            templateUrl: 'tpl/confirmation.html',
            controller: 'SignUpCtrl'
        })
            .state('app', {
            abstract: true,
            url: '/app',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
            //templateUrl: "tpl/blocks/material.layout.html"
        })
            .state('app.dashboard', {
            url: '/dashboard',
            templateUrl: 'tpl/dashboard.html',
            controller: 'DashboardCtrl'
        })
            .state('app.notifications', {
            url: '/notifications',
            templateUrl: 'tpl/notifications.html',
            controller: 'NotificationsCtrl'
        })
            .state('app.account', {
            url: '/account',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
        })
            .state('app.account.view', {
            url: '/view',
            templateUrl: 'tpl/view-account.html',
            controller: 'ViewAccountCtrl'
        })
            .state('app.account.edit', {
            url: '/edit',
            templateUrl: 'tpl/edit-account.html',
            controller: 'EditAccountCtrl'
        })
            .state('app.real-time', {
            url: '/real-time',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
        })
            .state('app.real-time.list', {
            url: '/list',
            templateUrl: 'tpl/real-time-list.html',
            controller: 'RealTimeListCtrl'
        })
            .state('app.real-time.map', {
            url: '/map',
            templateUrl: 'tpl/real-time-map.html',
            controller: 'RealTimeMapCtrl'
        })
            .state('app.reports', {
            url: '/reports',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
        })
            .state('app.reports.promo-granular', {
            url: '/:userId/promo-granular/:name/:activeData/:gId/:rankBy/:callType/:state/:dayPart',
            templateUrl: 'tpl/reports-promo-granular.html',
            controller: 'PromoGranularReportsCtrl'
        })
            .state('app.reports.campaigns', {
            url: '/campaigns',
            templateUrl: 'tpl/reports-campaigns.html',
            controller: 'ReportsCampaignsCtrl'
        })
            .state('app.reports.promo-numbers', {
            url: '/promo-numbers',
            templateUrl: 'tpl/reports-promo-numbers.html',
            controller: 'ReportsPromoNumbersCtrl'
        })
            .state('app.campaigns', {
            url: '/campaigns',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
        })
            .state('app.campaigns.list', {
            url: '/list',
            templateUrl: 'tpl/campaigns-list.html',
            controller: 'CampaignsListCtrl'
        })
            .state('app.campaigns.apply-list', {
            url: '/apply-list',
            templateUrl: 'tpl/campaigns-apply-list.html',
            controller: 'CampaignsApplyListCtrl'
        })
            .state('app.campaigns.apply', {
            url: '/apply/:campaignId',
            templateUrl: 'tpl/campaigns-apply-single-campaign.html',
            controller: 'CampaignsApplySingleCtrl'
        })
            .state('app.campaigns.view-statistics', {
            url: '/:campaignId/view-statistics',
            templateUrl: 'tpl/view-campaign-statistics.html',
            controller: 'ViewCampaignDetailsCtrl'
        })
            .state('app.campaigns.view-details', {
            url: '/:campaignId/view-details',
            templateUrl: 'tpl/view-campaign-details.html',
            controller: 'ViewCampaignDetailsCtrl'
        })
            .state('app.campaigns.campaign-leads', {
            url: '/:campaignId/campaign-leads',
            templateUrl: 'tpl/view-campaign-leads.html',
            controller: 'ViewCampaignDetailsCtrl'
        })
            .state('app.campaigns.campaign-leads-unsecure', {
            url: '/:campaignId/campaign-leads/unsecure',
            templateUrl: 'tpl/view-campaign-leads-unsecure.html',
            controller: 'ViewCampaignDetailsCtrl'
        })
            /* .state('app.campaigns', {
                 url: '/campaigns',
                 templateUrl: 'tpl/campaigns-list.html',
                 controller: 'CampaignsListCtrl'
             })
             .state('app.campaigns.apply-list', {
                 url: '/apply-list',
                 templateUrl: 'tpl/campaigns-list.html',
                 controller: 'CampaignsListCtrl'
             })*/
            .state('app.leads', {
            url: '/leads',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
        })
            .state('app.leads.lead-users-list', {
            url: '/lead-users-list',
            templateUrl: 'tpl/lead-users-list.html',
            controller: 'LeadUsersListCtrl'
        })
            .state('app.leads.view-lead-user-details', {
            url: '/:leadId/view-lead-user-details',
            templateUrl: 'tpl/lead-user-details.html',
            controller: 'LeadUserDetailsCtrl'
        })
            .state('app.publishers', {
            url: '/publishers',
            templateUrl: 'tpl/publishers.html'
        })
            .state('app.agent', {
            url: '/agent',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
        })
            .state('app.agent.dashboard', {
            url: '/:username/:userId/dashboard',
            templateUrl: 'tpl/agent-dashboard.html',
            controller: 'AgentDashboardCtrl'
        })
            .state('app.sales-agent', {
            url: '/:username/:userId',
            templateUrl: 'tpl/salesagent-dashboard.html',
            controller: 'AgentSalesDashboardCtrl'
        })
            .state('app.sales-agent.callhistory', {
            url: '/callhistory',
            templateUrl: 'tpl/blocks/call_history.html',
            controller: 'CallHistoryCtrl'
        })
            .state('app.sales-agent.contacts', {
            url: '/contacts',
            templateUrl: 'tpl/blocks/contactspage.html',
            controller: 'ContactsPageCtrl'
        })
            .state('app.sales-agent.details', {
            url: '/contact/:contactName/:phoneNumber',
            templateUrl: 'tpl/blocks/contact-details.html',
            controller: 'ContactDetailsCtrl'
        })
            .state('app.sales-agent.applications', {
            url: '/applications',
            templateUrl: 'tpl/blocks/application_page.html',
            controller: 'ApplicationPageCtrl'
        })
            .state('app.sales-agent.settings', {
            url: '/settings',
            templateUrl: 'tpl/blocks/settings_page.html',
            controller: 'SettingsPageCtrl'
        })
            .state('app.sales-agent.support', {
            url: '/support',
            templateUrl: 'tpl/blocks/support_page.html',
            controller: 'SupportPageCtrl'
        })
            .state('app.sales-agent.create-new-support', {
            url: '/createsupport',
            templateUrl: 'tpl/blocks/create_support_page.html',
            controller: 'CreateSupportPageCtrl'
        })
            .state('app.manage', {
            url: '/manage',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
        })
            .state('app.manage.promo-numbers', {
            url: '/promonumbers',
            templateUrl: 'tpl/promo-numbers.html',
            controller: 'ManagePromoNumbersCtrl'
        })
            .state('app.manage.pending-numbers', {
            url: '/promonumbers',
            templateUrl: 'tpl/promo-numbers-pending.html',
            controller: 'ManagePromoNumbersCtrl'
        })
            .state('app.integrations', {
            url: '/integrations',
            template: '<div ui-view class="fade-in-right-big smooth"></div>'
        })
            .state('app.integrations.all', {
            url: '/integrations-all',
            templateUrl: 'tpl/integrations-all.html',
            controller: 'IntegrationsAllCtrl'
        })
            .state('app.integrations.google-adwords', {
            url: '/google-adwords',
            templateUrl: 'tpl/integrations-google-adwords.html',
            controller: 'IntegrationsGoogleAdwordsCtrl'
        })
            .state('app.integrations.mailchimp', {
            url: '/mailchimp',
            templateUrl: 'tpl/integrations-mailchimp.html',
            controller: 'IntegrationsMailChimpCtrl'
        })
            .state('app.integrations.mailchimp-auth-callback', {
            url: '/mailchimp-auth-callback/:verified',
            templateUrl: 'tpl/integrations-mailchimp-config.html',
            controller: 'IntegrationsMailChimpConfigCtrl'
        })
            //http://127.0.0.1/app/integrations/mailchimp-auth-callback
            //http://127.0.0.1/app/integrations/mailchimp-auth-callback?code=b33c24e7676d3e44967505a7e0199e1d
            .state('app.integrations.google-adwords-activation', {
            url: '/google-adwords-activation',
            templateUrl: 'tpl/integrations-google-adwords-activation.html',
            controller: 'IntegrationsGoogleAdwordsCtrl'
        })
            .state('app.integrations.google-adwords-promo-numbers', {
            url: '/google-adwords-promo-numbers',
            templateUrl: 'tpl/integrations-google-adwords-promo-numbers.html',
            controller: 'IntegrationsGoogleAdwordsCtrl'
        })
            .state('app.integrations.google-adwords-promo-numbers-reports', {
            url: '/google-adwords-promo-numbers-reports/:sid/:userId',
            templateUrl: 'tpl/integrations-google-adwords-promo-numbers-reports.html',
            controller: 'IntegrationsGoogleAdwordsReportsCtrl'
        });
        //http://127.0.0.1/?code=55eb600bbb285d18121a31a8993fc3a7#/app/dashboard
        //http://127.0.0.1:8080/mailchimp/auth/callback?code=59cd57f5daf3e3455d5d909de011f899
        //  $locationProvider.html5Mode({
        //     enabled: true,
        // });
        // $locationProvider.html5Mode(true).hashPrefix('!');
        function load(srcs, callback) {
            return {
                deps: ['$ocLazyLoad', '$',
                    function ($ocLazyLoad, $q) {
                        var deferred = $q.defer();
                        var promise = false;
                        srcs = angular.isArray(srcs) ? srcs : srcs.split(/\s+/);
                        if (!promise) {
                            promise = deferred.promise;
                        }
                        angular.forEach(srcs, function (src) {
                            promise = promise.then(function () {
                                if (JQ_CONFIG[src]) {
                                    return $ocLazyLoad.load(JQ_CONFIG[src]);
                                }
                                angular.forEach(MODULE_CONFIG, function (module) {
                                    if (module.name == src) {
                                        // @ts-ignore
                                        name = module.name;
                                    }
                                    else {
                                        // @ts-ignore
                                        name = src;
                                    }
                                });
                                return $ocLazyLoad.load(name);
                            });
                        });
                        deferred.resolve();
                        return callback ? promise.then(function () { return callback(); }) : promise;
                    }]
            };
        }
    }
])
    .factory('httpApiProvider', ['$q', '$location', '$injector', '$window', '$rootScope', 'toaster', '$timeout',
    function ($q, $location, $injector, $window, $rootScope, toaster, $timeout) {
        var refreshInProgress = false;
        var tokenRefreshPromise = null;
        return {
            request: function (config) {
                var fileExtensionsToIgnore = ['.html', '.css', '.js', '.png', '.jpg', '.jpeg', '.gif', '.svg', '.woff', '.ttf'];
                if (config.url.includes('auth/token'))
                    return config;
                for (var i = 0; i < fileExtensionsToIgnore.length; i++) {
                    if (config.url.indexOf(fileExtensionsToIgnore[i], config.url.length - fileExtensionsToIgnore[i].length) !== -1) {
                        return config;
                    }
                }
                if ($location.absUrl().indexOf('app') !== -1 || config.url.includes('japi')) {
                    var token = $window.localStorage.getItem('access_token');
                    if (token) {
                        if (isTokenExpired(token)) {
                            console.log('Access token expired. Waiting for refresh...');
                            var deferred = $q.defer();
                            // Refresh logic
                            if (!refreshInProgress) {
                                refreshInProgress = true;
                                tokenRefreshPromise = retryTokenRefresh(12, 3000)
                                    .then(function (res) {
                                    var newToken = res.data.access_token;
                                    storeTokens(res.data);
                                    deferred.resolve(newToken);
                                    return newToken;
                                })
                                    .catch(function (err) {
                                    deferred.reject(err);
                                    // Only logout for authentication failures on the token refresh API itself
                                    if (err.status === 401 || err.status === 403 || err.status === 400) {
                                        if (err.config && err.config.url && err.config.url.includes('/auth/token')) {
                                            Sentry.captureMessage("Token refresh failed - request error: " + err.status, {
                                                level: "warning",
                                                fingerprint: ["token-refresh-auth-error-" + err.status],
                                                extra: { error: err }
                                            });
                                            handleLogout();
                                        }
                                        else {
                                            console.log('Auth error on token refresh for non-token API, not logging out');
                                        }
                                    }
                                    else if (isNetworkError(err)) {
                                        console.error('Network error during token refresh, will retry on next request');
                                        // Don't logout for network errors
                                    }
                                    else {
                                        console.error('Error refreshing token:', err);
                                    }
                                    return $q.reject(err);
                                })
                                    .finally(function () {
                                    refreshInProgress = false;
                                    tokenRefreshPromise = null;
                                });
                            }
                            return deferred.promise.then(function (newToken) {
                                config.headers = config.headers || {};
                                config.headers.Authorization = 'Bearer ' + newToken;
                                return config;
                            });
                        }
                        else {
                            config.headers = config.headers || {};
                            config.headers.Authorization = 'Bearer ' + token;
                        }
                    }
                    else {
                        if (!$location.absUrl().includes('access')) {
                            handleLogout();
                        }
                    }
                }
                return config;
            },
            responseError: function (response) {
                // console.log('responseError --->',response)
                if (response.status === 401 && !response.config._retry && !response.config.url.includes('auth/token')) {
                    response.config._retry = true;
                    if (!refreshInProgress) {
                        refreshInProgress = true;
                        tokenRefreshPromise = retryTokenRefresh(10, 3000)
                            .then(function (res) {
                            var newToken = res.data.access_token;
                            storeTokens(res.data);
                            response.config.headers = response.config.headers || {};
                            response.config.headers.Authorization = 'Bearer ' + newToken;
                            return $injector.get('$http')(response.config);
                        })
                            .catch(function (error) {
                            // Only logout for authentication failures on the token refresh API itself
                            if (error.status === 401 || error.status === 403 || error.status === 400) {
                                if (error.config && error.config.url && error.config.url.includes('/auth/token')) {
                                    Sentry.captureMessage("Token refresh failed - response error: " + error.status, {
                                        level: "warning",
                                        fingerprint: ["token-refresh-auth-error-" + error.status],
                                        extra: { error: error }
                                    });
                                    handleLogout();
                                }
                                else {
                                    console.log('Auth error on non-token API after refresh, not logging out');
                                }
                            }
                            else if (isNetworkError(error)) {
                                console.error('Network error during token refresh, will retry on next request');
                                // Don't logout for network errors
                            }
                            else {
                                console.error('Error refreshing token:', error);
                            }
                            return $q.reject(error);
                        })
                            .finally(function () {
                            refreshInProgress = false;
                            tokenRefreshPromise = null;
                        });
                        return tokenRefreshPromise;
                    }
                    else {
                        return tokenRefreshPromise.then(function (newToken) {
                            response.config.headers = response.config.headers || {};
                            response.config.headers.Authorization = 'Bearer ' + newToken;
                            return $injector.get('$http')(response.config);
                        });
                    }
                }
                // Handle network errors (connection issues, timeouts, server errors)
                else if (isNetworkError(response) && !response.config._networkRetry) {
                    // Mark this request as having been retried to prevent infinite loops
                    response.config._networkRetry = true;
                    // Simple exponential backoff for network errors
                    var retryDelay = response.config._retryCount ?
                        Math.min(1000 * Math.pow(2, response.config._retryCount), 10000) : 1000;
                    response.config._retryCount = (response.config._retryCount || 0) + 1;
                    // Don't retry more than 3 times for network issues
                    if (response.config._retryCount <= 3) {
                        console.log('Network error detected, retrying request after ' + retryDelay + 'ms delay...');
                        var deferred = $q.defer();
                        $timeout(function () {
                            $injector.get('$http')(response.config)
                                .then(deferred.resolve, deferred.reject);
                        }, retryDelay);
                        return deferred.promise;
                    }
                    console.error('Network error, max retries reached:', response);
                }
                return $q.reject(response);
            }
        };
        function retryTokenRefresh(maxAttempts, interval) {
            var attempts = 0;
            var deferred = $q.defer();
            function attempt() {
                attempts++;
                refreshAccessToken()
                    .then(deferred.resolve)
                    .catch(function (err) {
                    // Check for network errors (status 0 or specific error codes indicating network issues)
                    if (isNetworkError(err) && attempts < maxAttempts) {
                        $timeout(attempt, interval); // Retry after the specified interval
                    }
                    else {
                        // If it's not a network error or we've exhausted retries, reject and handle the error
                        deferred.reject(err);
                    }
                });
            }
            attempt();
            return deferred.promise;
        }
        function isNetworkError(error) {
            // console.log('isNetworkError --->', error);
            // No error or malformed error object
            if (!error) {
                return true;
            }
            // Check for common network error status codes in AngularJS $http
            if ([0, -1, 502, 503, 504].includes(error.status)) {
                return true;
            }
            // Check for typical AngularJS timeout scenario
            if (error.status === -1 && error.statusText === '') {
                return true;
            }
            // Check for any error without a proper status code
            if (error.status === undefined || error.status === null) {
                return true;
            }
            return false;
        }
        function handleLogout() {
            $rootScope.$broadcast('clearSession');
            toaster.pop('error', 'Error', 'Session Expired', 2000);
            $location.path('access/login');
        }
        function isTokenExpired(token) {
            if (!token)
                return true;
            var payload = decodeJwt(token);
            var currentTime = Math.floor(Date.now() / 1000);
            return currentTime > payload.exp;
        }
        function decodeJwt(token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(escape($window.atob(base64)));
            return JSON.parse(jsonPayload);
        }
        function refreshAccessToken() {
            var refresh_token = $window.localStorage.getItem('refresh_token');
            if (refresh_token) {
                var payload = {
                    "grantType": "refresh_token",
                    "clientId": "PUBLIC_CLIENT",
                    "refreshToken": refresh_token
                };
                return $injector.get('$http').post('/auth/token', payload);
            }
            else {
                console.log('No refresh token found.');
                return $q.reject('No refresh token');
            }
        }
        function storeTokens(response) {
            if (!response || !response.access_token || !response.refresh_token) {
                console.warn('Invalid token response, cannot store tokens:', response);
                Sentry.captureMessage("Invalid token response in storeTokens", {
                    level: "error",
                    extra: { response: response }
                });
                return;
            }
            if (typeof response.access_token !== 'string' || typeof response.refresh_token !== 'string' || response.access_token === response.refresh_token) {
                console.warn('Token values are invalid or identical:', { access: response.access_token, refresh: response.refresh_token });
                Sentry.captureMessage("Token values are invalid or identical in storeTokens", {
                    level: "error",
                    extra: { access_token: response.access_token, refresh_token: response.refresh_token }
                });
                return;
            }
            try {
                var existingAccess = $window.localStorage.getItem('access_token');
                var existingRefresh = $window.localStorage.getItem('refresh_token');
                if (response.access_token === existingAccess && response.refresh_token === existingRefresh) {
                    console.warn('Received tokens are identical to existing ones, possibly refresh not needed or failed:', { access_len: response.access_token.length });
                    Sentry.captureMessage("Tokens received are identical to existing ones", {
                        level: "warning",
                        extra: { access_len: response.access_token.length, refresh_len: response.refresh_token.length }
                    });
                }
                $window.localStorage.setItem('access_token', response.access_token);
                $window.localStorage.setItem('refresh_token', response.refresh_token);
                console.log('Tokens stored successfully:', { access_len: response.access_token.length, refresh_len: response.refresh_token.length });
            }
            catch (e) {
                console.warn('Failed to store tokens in localStorage:', e);
                Sentry.captureMessage("Failed to store tokens in localStorage", {
                    level: "error",
                    extra: { error: e, response: response }
                });
            }
        }
    }
])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('httpApiProvider');
    }])
    .run(['$rootScope', 'UserService', '$location', '$state',
    function ($rootScope, UserService, $location, $state) {
        $rootScope.$on("$stateChangeStart", function (event, toState, toParams) {
            if (toState.redirectTo) {
                event.preventDefault();
                $state.go(toState.redirectTo.state, toParams, { location: 'replace' });
            }
            // UserService.checkUserSessionWithServer();
            var checkRole = window.localStorage.getItem("role");
            var checkingAuthWithServer = UserService.getCheckingAuthWithServer();
            var isUserAuth = UserService.getCurrentUserAuthStatus();
            if (!checkingAuthWithServer && checkRole == 'AGENT') {
                if (isUserAuth == false) {
                    if ((toState.name == undefined || (toState.name != 'access.login'))) {
                        event.preventDefault();
                        $location.path("access/login");
                    }
                }
                if (isUserAuth == true && !$rootScope.httpInterceptorInProgress && (toState.name == undefined || toState.name == 'access.login')) {
                    event.preventDefault();
                    var username = window.localStorage.getItem("first_name");
                    var userid = window.localStorage.getItem("user_id");
                    var firstname = window.localStorage.getItem("first_name");
                    var lastname = window.localStorage.getItem("last_name");
                    var role = window.localStorage.getItem("role");
                    if (role === 'AGENT') {
                        role = 'salesagent';
                    }
                    console.log(role, "get role");
                    if (username !== null && userid !== null && role === 'useragent') {
                        $state.go('app.agent.dashboard', { 'username': username, 'userId': userid, 'first_name': firstname, 'last_name': lastname });
                    }
                    else if (username !== null && userid !== null && role === 'salesagent') {
                        $state.go('app.sales-agent', { 'username': username, 'userId': userid, 'first_name': firstname, 'last_name': lastname });
                    }
                    else {
                        var baseUrl = window.location.origin;
                        var newAppSignInPath = baseUrl + '/v2/sign-in';
                        if (role === 'AGENCY_OWNER') {
                            newAppSignInPath = baseUrl + '/v2/agency-owner/dashboard';
                        }
                        else if (role === 'MANAGER') {
                            newAppSignInPath = baseUrl + '/v2/manager/dashboard';
                        }
                        window.location.href = newAppSignInPath;
                    }
                }
            }
        });
    }
]);
